var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadge = function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0505",
    fillOpacity: 0.032,
    d: "M0 6C0 3.172 0 1.757.879.879 1.757 0 3.172 0 6 0s4.243 0 5.121.879C12 1.757 12 3.172 12 6v4c0 2.828 0 4.243-.879 5.121C10.243 16 8.828 16 6 16s-4.243 0-5.121-.879C0 14.243 0 12.828 0 10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D90003",
    strokeOpacity: 0.318,
    d: "M.5 6c0-1.428.001-2.45.105-3.225.103-.762.296-1.212.627-1.543S2.013.708 2.775.605C3.55.501 4.572.5 6 .5s2.45.001 3.225.105c.762.103 1.212.296 1.543.627s.524.781.627 1.543c.104.776.105 1.797.105 3.225v4c0 1.428-.001 2.45-.105 3.225-.103.762-.296 1.212-.627 1.543s-.781.524-1.543.627c-.776.104-1.797.105-3.225.105s-2.45-.001-3.225-.105c-.762-.103-1.212-.296-1.543-.627s-.524-.781-.627-1.543C.501 12.45.5 11.428.5 10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB0007",
    fillOpacity: 0.836,
    d: "M5.429 8.66 5.279 4h1.45l-.16 4.66zm.57 2.39a.83.83 0 0 1-.6-.22.76.76 0 0 1-.23-.56.73.73 0 0 1 .23-.55.8.8 0 0 1 .6-.23q.37 0 .6.23a.73.73 0 0 1 .23.55q0 .33-.23.56a.83.83 0 0 1-.6.22"
  })));
};
export default SvgBadge;